import { Anchor, Badge, Group, Paper, Table, Text, Title } from '@mantine/core'
import { jobApplicationStatusColor } from '../lib/jobApplicationStatusColors'

// #1127 admin 応募詳細のヘッダ。応募者 / 案件 / 企業 / 現在ステータス / 応募日 / 成約単価 / Slack スレッド。
// 値は Rails 側で組み立てて props で受け取り、ここでは描画のみ。earnings の編集は今回スコープ外(表示のみ)。
function Row({ label, children }) {
  return (
    <Table.Tr>
      <Table.Th w={140}>{label}</Table.Th>
      <Table.Td>{children}</Table.Td>
    </Table.Tr>
  )
}

export default function AdminJobApplicationSummary({
  applicantName,
  applicantHref,
  positionTitle,
  positionHref,
  companyName,
  status,
  statusLabel,
  appliedAt,
  updatedAt,
  earnings,
  slackThreadUrl,
}) {
  const applicant = applicantName || <Text c="dimmed" span>(退会ユーザー)</Text>
  const position = positionTitle || <Text c="dimmed" span>(タイトル未設定)</Text>

  return (
    <Paper withBorder p="md" mb="lg">
      <Group justify="space-between" align="flex-start" mb="sm" wrap="wrap">
        <div>
          <Title order={2} fz="h3">
            {applicantHref ? <Anchor href={applicantHref}>{applicant}</Anchor> : applicant}
          </Title>
          <Text fz="sm" c="dimmed">
            {positionHref ? <Anchor href={positionHref} fz="sm">{position}</Anchor> : position}
            {companyName ? ` / ${companyName}` : ''}
          </Text>
        </div>
        <Badge color={jobApplicationStatusColor(status)} variant="light" radius="sm" size="lg">
          {statusLabel}
        </Badge>
      </Group>

      <Table variant="vertical" layout="fixed" withTableBorder>
        <Table.Tbody>
          <Row label="応募日">{appliedAt}</Row>
          <Row label="最終更新">{updatedAt}</Row>
          <Row label="成約単価">
            {earnings == null ? <Text c="dimmed" span>未設定</Text> : `${Number(earnings).toLocaleString('ja-JP')} 円`}
          </Row>
          <Row label="Slack スレッド">
            {slackThreadUrl ? (
              <Anchor href={slackThreadUrl} target="_blank" rel="noopener noreferrer">
                Slack で開く
              </Anchor>
            ) : (
              <Text c="dimmed" span>未投稿</Text>
            )}
          </Row>
        </Table.Tbody>
      </Table>
    </Paper>
  )
}
